/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ConversationThreadContainer_comment = {
    readonly id: string;
    readonly rootParent: {
        readonly id: string;
        readonly author: {
            readonly id: string;
            readonly username: string | null;
        } | null;
        readonly createdAt: string;
        readonly " $fragmentRefs": FragmentRefs<"UserTagsContainer_comment" | "CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    } | null;
    readonly parentCount: number;
    readonly parents: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly id: string;
                readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "LocalReplyListContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
            };
        }>;
    };
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment">;
    readonly " $refType": "ConversationThreadContainer_comment";
};
export type ConversationThreadContainer_comment$data = ConversationThreadContainer_comment;
export type ConversationThreadContainer_comment$key = {
    readonly " $data"?: ConversationThreadContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ConversationThreadContainer_comment">;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any), v1 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "CommentContainer_comment"
    } as any), v2 = ({
        "args": null,
        "kind": "FragmentSpread",
        "name": "IgnoredTombstoneOrHideContainer_comment"
    } as any);
    return {
        "argumentDefinitions": [
            {
                "defaultValue": 0,
                "kind": "LocalArgument",
                "name": "count"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "cursor"
            }
        ],
        "kind": "Fragment",
        "metadata": {
            "connection": [
                {
                    "count": "count",
                    "cursor": "cursor",
                    "direction": "backward",
                    "path": [
                        "parents"
                    ]
                }
            ]
        },
        "name": "ConversationThreadContainer_comment",
        "selections": [
            (v0 /*: any*/),
            {
                "alias": null,
                "args": null,
                "concreteType": "Comment",
                "kind": "LinkedField",
                "name": "rootParent",
                "plural": false,
                "selections": [
                    (v0 /*: any*/),
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "author",
                        "plural": false,
                        "selections": [
                            (v0 /*: any*/),
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "username",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "createdAt",
                        "storageKey": null
                    },
                    {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "UserTagsContainer_comment"
                    },
                    (v1 /*: any*/),
                    (v2 /*: any*/)
                ],
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "parentCount",
                "storageKey": null
            },
            {
                "alias": "parents",
                "args": null,
                "concreteType": "CommentsConnection",
                "kind": "LinkedField",
                "name": "__ConversationThread_parents_connection",
                "plural": false,
                "selections": [
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "CommentEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "concreteType": "Comment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    (v0 /*: any*/),
                                    {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "__typename",
                                        "storageKey": null
                                    },
                                    (v1 /*: any*/),
                                    {
                                        "args": null,
                                        "kind": "FragmentSpread",
                                        "name": "LocalReplyListContainer_comment"
                                    },
                                    (v2 /*: any*/)
                                ],
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                            },
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            },
            (v1 /*: any*/),
            (v2 /*: any*/)
        ],
        "type": "Comment",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '7924601db9735ae97447f96d5032c5a7';
export default node;
